import CenteredContent from 'components/CenteredContent/CenteredContent';
import useMobileView from 'hooks/useMobileView';

export const CoverSectionSkeletonDesktop = () => {
  return (
    <CenteredContent>
      <section className="hero skeleton" style={{ height: '276px' }} />
    </CenteredContent>
  );
};

export const CoverSectionSkeletonMobile = () => {
  return <section className="hero skeleton" />;
};

const CoverSectionSkeleton = () => {
  const { isMobile } = useMobileView();

  if (isMobile) {
    return <CoverSectionSkeletonMobile />;
  }

  return <CoverSectionSkeletonDesktop />;
};

export default CoverSectionSkeleton;
